import React from 'react';

import { WORKSPACE_FOLDER_ROUTE } from '../../../entities/history/config';

import { useRouteMatch } from 'react-router-dom';

import { WorkspaceFolderPage } from './WorkspaceFolderPage';
import { WorkspaceAllPages } from './WorkspaceAllPages';

export const WorkspacePage: React.FC = () => {
  const isFolderPage = useRouteMatch({
    path: WORKSPACE_FOLDER_ROUTE,
    exact: true,
  });

  if (isFolderPage) {
    return <WorkspaceFolderPage />;
  }

  return <WorkspaceAllPages />;
};
